import { Dropdown } from 'component/Dropdown/Dropdown'
import { Option } from 'component/Select/Option'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { ReactNode, useState } from 'react'

export type Value = string

export type SelectProps = {
  value: string | undefined
  options: Option[]
  onChange(value: Value): void
  children?: ReactNode
}

export function Select(props: SelectProps) {
  const { value, options, onChange, children } = props
  const option = options.find((o) => o.value === value)
  const [open, setOpen] = useState(false)

  const onSelect = useLatestCallback((option: Option) => {
    onChange(option.value)
  })

  const renderOption = useLatestCallback((option: Option) => {
    const label = option.label ?? option.value
    return (
      <Space>
        <Typo size={11} medium upper>
          {label}
        </Typo>
      </Space>
    )
  })

  return (
    <Dropdown
      height={32}
      options={options}
      renderOption={renderOption}
      onSelect={onSelect}
      onOpen={setOpen}
      buttonPadSmall
    >
      <Space gap={4}>
        <Space>{children ? children : option ? renderOption(option) : null}</Space>
        <Space margin={[null, -4, null, null]}>
          <Icon
            size={12}
            name={open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
            style={{ opacity: 0.5 }}
          />
        </Space>
      </Space>
    </Dropdown>
  )
}
